import ShowToast from '@/Components/Toast/showToastTemplate';

// In cases where multiple toasts are expected to trigger in quick succession,
// delaying the display of the current toast ensures it doesn't get immediately
// overridden or missed due to the subsequent toasts being triggered shortly after.
const ShowToastWithDelay = (params, delay = 500) => {
  let updatedParams = params;
  if (!params.toastId) {
    const toastId = generateRandomString(6);
    updatedParams = { ...params, toastId };
  }

  setTimeout(() => {
    ShowToast(updatedParams);
  }, delay);
};

const generateRandomString = (length) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

export default ShowToastWithDelay;
